import { createRouter, createWebHistory } from "vue-router";

const host = window.location.hostname;

const getHomeComponent = () => {
  if (host.includes('pareekshak')) {
    return () => import('@/apps/edtech/Assessments.vue');
  }
  if (host.includes('blockgen')) {
    return () => import('@/apps/art/Home.vue');
  }
  return () => import('@/apps/capital/Dashboard.vue');
  //return () => import('@/views/Grader.vue');
};

const routes = [
  {
    path: "/:orgCode?",
    name: "Landing",
    component: getHomeComponent(),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/loginTG",
    name: "LoginTG",
    component: () => import("@/views/TelegramLogin.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
  },
  {
    path: "/demo",
    name: "Demo",
    component: () => import("@/apps/edtech/Demo.vue"),
  },
  {
    path: "/trade",
    name: "Trade",
    component: () => import("@/components/KiteConnectApp.vue"),
  },
  {
    path: "/assessments",
    name: "Assessments",
    component: () => import("@/apps/edtech/Assessments.vue"),
  },
  {
    path: "/research/technicals",
    name: "Technicals",
    component: () => import("@/views/TechnicalResearch.vue"),
  },
  {
    path: "/research/fundamentals",
    name: "Fundamentals",
    component: () => import("@/views/FundamentalResearch.vue"),
  },
  {
    path: "/strategies",
    name: "strategies",
    component: () => import("@/apps/capital/Dashboard.vue"),
  },
  {
    path: "/statistics",
    name: "statistics",
    component: () => import("@/apps/capital/statistics.vue"),
  },
  {
    path: "/tools",
    name: "Tools",
    component: () => import("@/apps/capital/tools.vue"),
  },
  {
    path: "/aboutus",
    name: "About Us",
    component: () => import("@/apps/capital/aboutus.vue"),
  },

  {
    path: "/code/:uuid?",
    name: "Chats",
    component: () => import("@/apps/capital/Chats.vue"),
  },
  {
    path: "/share/:uuid?",
    name: "SharedChat",
    component: () => import("@/apps/capital/SharedChat.vue"),
  },

  {
    path: "/executions/:chat_id?/:shared_flag?",
    name: "ExecutionViewer",
    component: () => import("@/apps/capital/ExecutionViewer.vue"),
  },

  {
    path: "/company/:symbol",
    name: "Company",
    component: () => import("@/views/Company.vue"),
    props: true,
  },
  {
    path: "/report",
    name: "Company Search",
    component: () => import("@/apps/capital/report.vue"),
    props: true,
  },
  {
    path: "/candles",
    name: "Candles",
    component: () => import("@/views/Candles.vue"),
    props: true,
  },
  {
    path: "/optionsChain",
    name: "OptionsChain",
    component: () => import("@/views/OptionsChain.vue"),
    props: true,
  },
  {
    path: "/prompts",
    name: "Prompts",
    component: () => import("@/views/Prompts.vue"),
    props: true,
  },
]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;